export interface WomBasketCreateRequest {
  workOrderComplementId: number;
  customerId: number;
  vehicleId: number;
  companyId: number;
  basket: {
    orderNumber: string;
    additionalInformation?: string;
    basketName: string;
  };
}

export interface WomBasketCreateResponse {
  id: number;
  workOrderComplementId: number;
  companyId: number;
  matrixId: number;
  customerId: number;
  vehicleId: number;
  basketId: string;
  basketName: string;
  orderNumber: string;
  linkBasket: string;
}

export interface WomBasketBaseRequest {
  workOrderComplementId: number;
  orderNumber: string;
  additionalInformation: string;
  basketName: string;
}

export enum WomBasketStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  ORDERED = 'ORDERED',
  PARTIALLY_ORDERED = 'PARTIALLY_ORDERED',
}

export const WomBasketStatusLabel = {
  [WomBasketStatus.IN_PROGRESS]: 'Em progresso',
  [WomBasketStatus.ORDERED]: 'Ordenado',
  [WomBasketStatus.PARTIALLY_ORDERED]: 'Parcialmente ordenado',
};

export const WomBasketStatusColor = {
  [WomBasketStatus.IN_PROGRESS]: 'blue',
  [WomBasketStatus.ORDERED]: 'green',
  [WomBasketStatus.PARTIALLY_ORDERED]: 'yellow',
};

export interface WomBasketBaseResponse {
  id: string;
  buyerOrderNr: string;
  status: WomBasketStatus;
  archived: true;
  additionalInformation?: string;
  name: string;
  _links: {
    self: {
      href: string;
    };
    customerData: {
      href: string;
    };
    vehicle: {
      href: string;
    };
    vehicleData: {
      href: string;
    };
    items: {
      href: string;
    };
    laborItems: {
      href: string;
    };
    ui: {
      href: string;
    };
    uiAutoStartSession: {
      href: string;
    };
    uiAutoStartbisSession: {
      href: string;
    };
  };
}

export interface WomBasketListRequest {
  nextToken?: string;
  rows?: number;
  licensePlate?: string;
  order?: 'ASC' | 'DESC';
  workOrderNumber?: string;
  basketName?: string;
}

export interface WomBasket {
  id: number;
  companyId: number;
  workOrderComplementId: number;
  matrixId: number;
  customerId: number;
  vehicleId: number;
  licensePlate: string;
  customerName: string;
  basketId: string;
  basketName: string;
  orderNumber: string;
  linkBasket: string;
}

export interface WomBasketListResponse {
  data: WomBasket[];
  nextToken: string;
}
